import IconHouseSolid from '@/assets/icons/font_awesome/house-solid.svg?react';
import { use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { try_set_default_workspace } from '@/utils/utils_client_workspace_child_entity_viewers';
import { UI_PRIMITIVE__icon_animated } from '../../../../components/ui/UI_PRIMITIVE__icon_animated';
import { UI_PRIMITIVE__tooltip } from '../../../../components/ui/UI_PRIMITIVE__tooltip';

export function ButtonWorkspaceGoToDefault() {
  const { is_authorized, user_settings } = use_slice_user(['is_authorized', 'user_settings']);
  const { workspace_current } = use_slice_workspace(['workspace_current']);

  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    await try_set_default_workspace();
  }

  /*
   * HTML
   */
  if (workspace_current._id === user_settings.default_workspace_id) return <></>;
  if (!is_authorized) return <></>; //not authorized

  return (
    <UI_PRIMITIVE__tooltip tooltip_title="Go to default workspace">
      <span
        className="absolute size-full backdrop-blur-sm backdrop-brightness-50 opacity-0 hover:opacity-100 duration-300 cursor-pointer flex items-center justify-center"
        onClick={onClick}
      >
        <UI_PRIMITIVE__icon_animated className="!w-7 !h-7 !text-component-item-foreground" Icon={IconHouseSolid} renderDelay={0} />
      </span>
    </UI_PRIMITIVE__tooltip>
  );
}
